import { generateRandomKey } from '@/helper/upload';
import i18n from '@/plugin/i18n';

export default {
    namespaced: true,
    state: {
        generalUpload: true,
        uploadFiles: [],
    },
    getters: {
        uploadFiles: state => state.uploadFiles,
        generalUpload: state => state.generalUpload,
        totalProgress: (state) => {
            const uploadingProgram = state.uploadFiles.filter(file => file.status !== 'fail' && file.status !== 'cancel');
            if (uploadingProgram.length === 0) {
                return null;
            }

            const initSum = 0;

            const progressSum = uploadingProgram.reduce((beforeSum, currentValue) => beforeSum + currentValue.progress, initSum);

            return Math.floor(progressSum / uploadingProgram.length);
        },
        uploadUrlApi: (state, getters, rootState, rootGetters) => `/cms/${rootGetters.selectedServiceAccount.key}/programs/upload_file_to_wait_category`,
    },
    mutations: {
        setSingleUpdateUploadFiles(state, { id, data }) {
            const index = state.uploadFiles.findIndex(el => el.id === id);
            state.uploadFiles.splice(index, 1, data);
        },
        setRemoveUploadFile(state, id) {
            const index = state.uploadFiles.findIndex(el => el.id === id);
            state.uploadFiles.splice(index, 1);
        },
        setInitUploadFiles(state, payload) {
            const initPayload = payload.map((file) => {
                const generateKey = generateRandomKey(10, state.uploadFiles);

                return {
                    id: generateKey,
                    file,
                    name: file.name,
                    uploadUrl: '',
                    source: '',
                    progress: 0,
                    status: 'wait',
                    errorMessage: '',
                };
            });

            state.uploadFiles = [
                ...state.uploadFiles,
                ...initPayload,
            ];
        },
        setClearCompleteUploadFiles(state) {
            state.uploadFiles = state.uploadFiles.filter(el => el.status === 'wait' || el.status === 'uploading');
        },
        setGeneralUpload(state, payload) {
            state.generalUpload = payload;
        },
    },
    actions: {
        async postUploadFiles({ getters, commit }, payload) {
            await commit('setInitUploadFiles', payload);

            if (getters.uploadFiles.length > 0) {
                getters.uploadFiles.map(async (fileInfo, index) => {
                    if (fileInfo.status !== 'wait') {
                        return fileInfo;
                    }

                    const updateFileInfo = {
                        ...fileInfo,
                    };

                    const formData = new FormData();
                    formData.append('upload_file', fileInfo.file);

                    updateFileInfo.source = axios.CancelToken.source();

                    updateFileInfo.uploadUrl = getters.uploadUrlApi;

                    axios.post(`${updateFileInfo.uploadUrl}`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                        cancelToken: updateFileInfo.source.token,
                        onUploadProgress: (event) => {
                            const totalLength = event.lengthComputable
                                ? event.total
                                : event.target.getResponseHeader('content-length')
                                || event.target.getResponseHeader('x-decompressed-content-length');
                            if (totalLength != null) {
                                const progressPercent = Math.round((event.loaded * 100) / event.total);
                                updateFileInfo.progress = progressPercent;

                                updateFileInfo.status = 'uploading';
                            }

                            commit('setSingleUpdateUploadFiles', {
                                id: updateFileInfo.id,
                                data: updateFileInfo,
                            });
                        },
                    }).catch((error) => {
                        if (error.message === 'User canceled') {
                            updateFileInfo.status = 'cancel';
                        } else {
                            updateFileInfo.status = 'fail';
                            updateFileInfo.errorMessage = error.response && error.response.data.errors ? Object.values(error.response.data.errors)[0][0] : i18n.t('paragraphs.program_upload_fail_error');
                        }

                        commit('setSingleUpdateUploadFiles', {
                            id: updateFileInfo.id,
                            data: updateFileInfo,
                        });
                    });

                    return fileInfo;
                });
            }
        },
        async resendUploadFile({ getters, commit }, uploadFileId) {
            const updateFileInfo = getters.uploadFiles.find(file => file.id === uploadFileId);

            updateFileInfo.source = axios.CancelToken.source();

            updateFileInfo.uploadUrl = getters.uploadUrlApi;

            commit('setSingleUpdateUploadFiles', {
                id: updateFileInfo.id,
                data: updateFileInfo,
            });


            const formData = new FormData();
            formData.append('upload-file', updateFileInfo.file);

            axios.post(`${updateFileInfo.uploadUrl}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                cancelToken: updateFileInfo.source.token,
                onUploadProgress: (event) => {
                    const totalLength = event.lengthComputable
                        ? event.total
                        : event.target.getResponseHeader('content-length')
                        || event.target.getResponseHeader('x-decompressed-content-length');
                    if (totalLength != null) {
                        const progressPercent = Math.round((event.loaded * 100) / event.total);
                        updateFileInfo.progress = progressPercent;

                        updateFileInfo.status = 'uploading';
                    }

                    commit('setSingleUpdateUploadFiles', {
                        id: updateFileInfo.id,
                        data: updateFileInfo,
                    });
                },
            }).catch((error) => {
                if (error.message === 'User canceled') {
                    updateFileInfo.status = 'cancel';
                } else {
                    updateFileInfo.status = 'fail';
                    updateFileInfo.errorMessage = error.response && error.response.data.errors ? Object.values(error.response.data.errors)[0][0] : i18n.t('paragraphs.program_upload_fail_error');
                }

                commit('setSingleUpdateUploadFiles', {
                    id: updateFileInfo.id,
                    data: updateFileInfo,
                });
            });
        },
    },
};
